export default __webpack_public_path__ + "glyphicons-halflings-regular.ttf";